import React from "react";
import classes from "./AccountTrigger.module.css";
import { useAccountTrigger } from "../../Pregrine/AccountTrigger/useAccountTrigger";
import { Link } from "react-router-dom";
import AccountDropDown from "../AccountDropDown/AccountDropDown";
import Shimmer from "../../components/Shimmer/shimmer";

const AccountTrigger = () => {
  const talonProps = useAccountTrigger();
  const {
    handleAccountTrigger,
    isSignedIn,
    currentUser,
    accountIsOpen,
    accountRef,
    accountTriggerRef,
  } = talonProps;

  return (
    <>
      {!isSignedIn ? (
        <>
          <Link to="/sign-in" className={classes.signIn}>
            <svg
              style={{ marginRight: "10px" }}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon-icon-A2I"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </Link>
        </>
      ) : (
        <button
          ref={accountTriggerRef}
          className={classes.signIn}
          onClick={handleAccountTrigger}
          style={{ backgroundColor: " #42A9D6" }}
        >
          {currentUser ? (
            <>{currentUser.firstname[0] + currentUser.lastname[0]}</>
          ) : (
            <>
              <Shimmer width={"92px"} height={"25px"} />
            </>
          )}
        </button>
      )}

      {accountIsOpen && (
        <AccountDropDown
          accountRef={accountRef}
          accountIsOpen={accountIsOpen}
          handleAccountTrigger={handleAccountTrigger}
        />
      )}
    </>
  );
};

export default AccountTrigger;
